import { map } from "lodash";
import { useCurrentProject } from "./useCurrentProject";

export function useCurrentProjectFocusesId() {
  const project = useCurrentProject();
  return map(project.focuses, "id");
}
